import { render, staticRenderFns } from "./custom-video.vue?vue&type=template&id=cbadea90&scoped=true&"
import script from "./custom-video.vue?vue&type=script&lang=js&"
export * from "./custom-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbadea90",
  null
  
)

export default component.exports